import { getDataSource, getMe } from 'legacy/store/appReducer';
import { DATASOURCES } from 'legacy/constants';

// URL functions
import { fetchKardiaRxIdtfEcg } from 'legacy/containers/ApiUrls';

// Constants Types
import ROUTE_PATHS from '../../../routes/routePaths';
import {
  CCT_ECG_TABLE_DATA_REQUEST,
  CCT_ECG_TABLE_DATA_SUCCESS,
  CCT_ECG_TABLE_DATA_FAILURE,
  CCT_SELECTED_PATIENT,
  CCT_SELECTED_RECORDING,
} from './types';

import { updateRxPatient as ECGHistoryUpdateRxPatient } from '../KardiaRxCCTPatientHistory/KardiaRxCCTPatientHistoryActions';

import history from '../../../legacy/containers/History';

// ------------------------------------
// Actions
// ------------------------------------
export const kardiRxCctEcgTableDataRequest = () => ({
  type: CCT_ECG_TABLE_DATA_REQUEST,
});
export const kardiRxCctEcgTableDataSuccess = data => ({
  type: CCT_ECG_TABLE_DATA_SUCCESS,
  payload: data,
});
export const kardiRxCctEcgTableDataFailure = () => ({
  type: CCT_ECG_TABLE_DATA_FAILURE,
});

export const updateRxPatient = patient => ({
  type: CCT_SELECTED_PATIENT,
  payload: patient,
});

export const updateRxRecording = rec => ({
  type: CCT_SELECTED_RECORDING,
  payload: rec,
});

export const setInitialKardiaRxCCTEcgTableData = (match, location) => (
  dispatch,
  getState,
) => {
  const { patientId } = match.params;
  const { search } = location;
  const templetArr = search.split('idtf_connection_id=');
  dispatch(
    updateRxPatient({
      participantId: patientId,
      idtf_connection_id: templetArr[1],
    }),
  );
};

export const getKardiaRxCCTEcgTableData = (forceUpdate = false) => (
  dispatch,
  getState,
) => {
  dispatch(kardiRxCctEcgTableDataRequest());
  const meDataSource = getDataSource(getState(), DATASOURCES.ME);
  console.log(
    'kardiaRx=>>',
    getState().kardiaRx.kardiaRxCCTEcg.selectedPatinet,
  );
  const {
    idtf_connection_id,
  } = getState().kardiaRx.kardiaRxCCTEcg.selectedPatinet;
  let promises;

  if (meDataSource.data && !forceUpdate) {
    promises = Promise.resolve();
  } else {
    promises = dispatch(getMe());
  }

  return promises
    .then(() => {
      const me = getDataSource(getState(), DATASOURCES.ME);
      const { teams } = me.data;
      const apiCalls = [];
      apiCalls.push(dispatch(fetchKardiaRxIdtfEcg(idtf_connection_id)));
      return Promise.all(apiCalls);
    })
    .then(data => {
      return dispatch(kardiRxCctEcgTableDataSuccess(data));
    })
    .catch(err => {
      dispatch(kardiRxCctEcgTableDataFailure(err));
    });
};

export const updatedSelectedKardiaRxPatient = data => dispatch => {
  dispatch(updateRxPatient(data));
};

export const updatedSelectedRxRecording = data => dispatch => {
  dispatch(updateRxRecording(data));
};

export const routeChangeAction = RecordingID => (dispatch, getState) => {
  const selectedPatients = getState().kardiaRx.kardiaRxCCTEcg.selectedPatinet;
  dispatch(ECGHistoryUpdateRxPatient(selectedPatients));
  history.push(
    `${ROUTE_PATHS.EKG_REVIEW_EKG_ANNOTATION}/${RecordingID}/${selectedPatients.idtf_connection_id}`,
  );
};



// WEBPACK FOOTER //
// ./src/views/state/KardiaRxCCTPatient/KardiaRxCCTEcgTableActions.js